<h2>Notification management</h2>

<div class="alert_group">
    <ng-container *ngFor="let alert of alertNotif?.notifications, let i = index">
        <div class="alert_line">
            <div class="notifType">
                {{alert.notificationType.label}}
            </div>
            <div class="param" *ngIf="alert.notificationType.label !== 'NewAlert'">
                <mat-form-field appearance="outline">
                    <mat-label>
                        setting</mat-label>
                    <input type="number" [(ngModel)]="model[i]" matInput
                        (input)="updatePushUser($event, alert, i, 'parameterValue')" [value]="alert.parameterValue">
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
            <div class="checkbox">
                <mat-checkbox color="primary" (change)="updatePushUser($event, alert, i, 'email')"
                    [checked]="alert.email">by
                    email
                </mat-checkbox>
                <mat-checkbox color="primary" [disabled]="gsm()" matTooltip="please, update the phone number"
                    [matTooltipDisabled]="gsmNull()" titlecolor="primary"
                    (change)="updatePushUser($event, alert, i, 'sms')" [checked]="alert.sms">
                    by sms
                </mat-checkbox>
            </div>
        </div>

    </ng-container>
<div class="button">
    <button class="canceled" type="button" (click)="dialog.closeAll()">Cancel</button>
    <button class="add" type="submit" mat-raised-button color="primary" (click)="onSubmit()">Confirm</button>
</div>
</div>
